import { fileObjectSchema } from "@boark/shared/types/file-object";
import * as z from "zod";

import { getRequest } from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getFiles(path: string) {
  return getRequest(
    `${API_BASE_URL}/file?path=${encodeURIComponent(path)}`,
    z.array(fileObjectSchema),
  );
}
